export const shouldBlockInviteForApplicationResources = ({
  hasLoadedCurrentWorkspaceResources,
  isLoading,
  loadError,
}: {
  hasLoadedCurrentWorkspaceResources: boolean;
  isLoading: boolean;
  loadError: string | null;
}): boolean =>
  !loadError && (isLoading || !hasLoadedCurrentWorkspaceResources);

const PROJECT_ASSIGNMENT_ACCESS_CEILING_ERROR =
  'project_assignment.access_ceiling_exceeded';

export const isProjectAssignmentAccessCeilingError = (
  error: unknown,
): boolean => {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === 'string'
        ? error
        : '';

  return message.includes(PROJECT_ASSIGNMENT_ACCESS_CEILING_ERROR);
};
